import { X } from 'lucide-react';
import type { ToastMessage, ToastTone } from './useToast';

const TONE_COLOR: Record<ToastTone, string> = {
  success: 'var(--co-success)',
  error: 'var(--co-error)',
  info: 'var(--co-info)',
};

interface Props {
  toast: ToastMessage | null;
  onDismiss: () => void;
}

export function Toast({ toast, onDismiss }: Props) {
  if (!toast) return null;
  const color = TONE_COLOR[toast.tone];
  return (
    <div
      role={toast.tone === 'error' ? 'alert' : 'status'}
      className="fixed bottom-4 right-4 z-[60] flex items-center gap-2 rounded-lg border px-3 py-2 text-[12px] font-medium shadow-lg"
      style={{ color, borderColor: color, backgroundColor: 'var(--co-surface)' }}
    >
      <span>{toast.text}</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss notification"
        className="rounded p-0.5 hover:bg-[var(--co-bg)]"
      >
        <X size={12} aria-hidden="true" />
      </button>
    </div>
  );
}
